import dayjs from "dayjs";

export const getTwelveHourTime = (time: string, hasDayIndicator?: boolean) => {
    const format = hasDayIndicator ? 'hh:mma' : 'hh:mm';
    return dayjs('1/1/1 ' + time).format(format);
};